
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
const AppState = getModule(AppModule, store);

@Component
export default class EmailDisplay extends Vue {
  @Prop() width!: string;

  get getSideBarOpen() {
    return AppState.sidebarOpen;
  }
}
